import Vue from 'vue';
import App from './App';
import './main';
import router from './router/index.js';
import 'pix-sdk';
import Xui from 'pix-xui';
import 'pix-xui/lib/theme-cbg/index.css';
import './global/base.css';
import './index.css';
import './global/gt.js';
import Axios from 'axios';
import VueAxios from 'vue-axios';
import VueCookies from 'vue-cookies';
import Meta from 'vue-meta';
import xss from './axiosconfig/xss';
import store from './store/index.js';
import Login from './views/login/login.vue';
import moment from 'moment';
import { getAgent } from '../src/utils/utils';
import iconfont from './assets/font/iconfont.css';
import './assets/font/iconfont';
Vue.prototype.$moment = moment;

Vue.component('Login', Login); //全局自定义组件

import zhLocale from '../src/locale/lang/zh-CN';
window.hwit.i18n.use(zhLocale);

// const isPro = Object.is(process.env.NODE_ENV, 'production')
// Axios.defaults.baseURL = isPro ? 'https://hsrc-uat.itsec.hihonor.com/hsrc/vul/gateway/' : ''
const hostType = window.location.host;
let baseU = '';
let defaultAvatar = '';
let appId = '';
// eslint-disable-next-line @workplace/xui/no-http-https
Vue.prototype.$privacyURL = 'https://apigw-beta.test.hihonor.com/api/ams/asm/agrFile/getHtmlFile?agrNo=1047&country=cn&branchId=0&langCode=zh-cn';
// eslint-disable-next-line @workplace/xui/no-http-https
Vue.prototype.$safetyURL = 'https://apigw-beta.test.hihonor.com/api/ams/asm/agrFile/getHtmlFile?agrNo=1046&country=cn&branchId=0&langCode=zh-cn';
if (hostType === 'security.honor.com') {
    // 生产环境
    Axios.defaults.baseURL = 'https://security.honor.com/hsrc/vul/gateway/';
    baseU = 'security';
    defaultAvatar = '63620680540987392';
    appId = 'ad3b481039e849d3a3b9797aff86de59';
    // eslint-disable-next-line @workplace/xui/no-http-https
    Vue.prototype.$privacyURL = 'https://agreement.itsec.hihonor.com/asm/agrFile/getHtmlFile?agrNo=1047&country=cn&branchId=0&langCode=zh-cn';
    // eslint-disable-next-line @workplace/xui/no-http-https
    Vue.prototype.$safetyURL = 'https://agreement.itsec.hihonor.com/asm/agrFile/getHtmlFile?agrNo=1046&country=cn&branchId=0&langCode=zh-cn';
} else if (hostType === 'hsrc-uat.test.honor.com') {
    // 测试环境
    Axios.defaults.baseURL = 'https://hsrc-uat.test.honor.com/hsrc/vul/gateway/';
    baseU = 'hsrc-uat.test';
    defaultAvatar = '37820107627692032';
    appId = '6c76ec3551044210a1e9ab8c45a6e9e8';
} else if (hostType === 'hsrc-sit.test.honor.com') {
    // 测试环境
    Axios.defaults.baseURL = 'https://hsrc-sit.test.honor.com/hsrc/vul/gateway/';
    baseU = 'hsrc-sit.test';
    defaultAvatar = '37820107627692032';
    appId = '6c76ec3551044210a1e9ab8c45a6e9e8';
} else if (hostType === 'localhost:8080') {
    // 本地环境
    Axios.defaults.baseURL = '';
    baseU = 'hsrc-uat.test';
    defaultAvatar = '37820107627692032';
    appId = '6c76ec3551044210a1e9ab8c45a6e9e8';
}
Vue.prototype.$baseURL = Axios.defaults.baseURL;
Vue.prototype.$baseU = baseU;
Vue.prototype.$defaultAvatar = defaultAvatar;
Vue.prototype.$appId = appId;
Axios.defaults.withCredentials = true;

Vue.use(Xui);
Vue.use(VueCookies);
if (window.sessionStorage.getItem('x-csrf-token')) {
    window.sessionStorage.removeItem('x-csrf-token');
}
Axios.interceptors.response.use(
    function(response) {
        if (!(response.config.url.includes('web/support/workspace/current') || response.config.url.includes('services/user/getUserInfo'))) {
            if (typeof response.data === 'string') {
                window.location.reload();
            }
        }
        return response;
    },
    function(error) {
        if (error.response && error.response.data && error.response.data.code === 'hihonor.account.00010010') {
            return Promise.reject(error);
        }
        if (error.response && error.response.data && error.response.data.status === 418) {
            Vue.prototype.$message.error('提醒：您提交的内容可能对网站造成危险，已被网站管理员设置拦截，请检查内容并修改后重试！');
        }
        if (error.response && error.response.data && error.response.data.status === 401) {
            window.location.reload();
        }
        if (error.response && error.response.data && error.response.data.message) {
            Vue.prototype.$message.error(error.response && error.response.data && error.response.data.message);
        }
        return Promise.reject(error);
    }
);

const setCsrf = function() {
    return new Promise((resolve, reject) => {
        Axios.get('common/hsrc/vul/common/services/jalor/web/support/workspace/current', {
            headers: {
                'x-multi-consumer-appid': 'hsrc_vul-x-service-multi',
                appid: appId,
                'x-celon-admin': true,
                'x-sub-app-id': 'hsrc_vul',
                'x-csrf-token': window.sessionStorage.getItem('x-csrf-token')
            }
        })
            .then(res => {
                if (res && res['headers'] && res['headers']['x-csrf-token']) {
                    window.sessionStorage.setItem('x-csrf-token', res['headers']['x-csrf-token']);
                    Axios.interceptors.request.use(
                        function(config) {
                            config.withCredentials = true;
                            const token = window.sessionStorage.getItem('x-csrf-token');
                            config['headers']['x-csrf-token'] = token;
                            resolve(true);
                            return config;
                        },
                        function(error) {
                            // 对返回的错误进行处理
                            return Promise.reject(error);
                        }
                    );
                    resolve(true);
                }
            })
            .catch(error => {
                reject(error);
            });
    });
};

Vue.prototype.$setCsrf = setCsrf;
Vue.use(Meta);
Vue.use(VueAxios, Axios);

new Vue({
    el: '#app',
    router,
    store,
    beforeCreate() {
        Vue.prototype.$bus = this;
        getAgent();
    },
    render: h => h(App)
});

console.log('当前环境：', process.env.NODE_ENV);
console.log('当前host：', window.location.host);



// WEBPACK FOOTER //
// ./src/main.js